(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FINISHES = ['gold', 'white-gold', 'rose-gold'];

    function buildSwatches() {
      var group = document.createElement('div');
      group.className = 'carousel-card__swatches';
      group.setAttribute('aria-hidden', 'true');
      for (var index = 0; index < FINISHES.length; index++) {
        var disc = document.createElement('span');
        disc.className = 'carousel-card__swatch carousel-card__swatch--' + FINISHES[index];
        group.appendChild(disc);
      }
      return group;
    }

    function injectSwatches(section) {
      if (section.getAttribute('data-show-metal-swatches') !== 'true') return;
      var cards = section.querySelectorAll('[data-carousel-card] .card__inner');
      cards.forEach(function (inner) {
        if (inner.querySelector('.carousel-card__swatches')) return;
        inner.appendChild(buildSwatches());
      });
    }

    function init() {
      document
        .querySelectorAll('.section-carousel[data-show-metal-swatches]')
        .forEach(injectSwatches);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.section-carousel[data-show-metal-swatches]');
      if (section) injectSwatches(section);
    });

    /* ----- F4: Patch blank alt text on carousel card images -----
       The image block (blocks/image.liquid) emits image_tag without an alt:
       parameter, producing alt="" on every card image. WCAG 2.1 AA requires
       non-empty alt on meaningful images. Set a descriptive fallback alt on
       any card image within this section that has an empty alt attribute.
       Scoped to .section-carousel so other sections are unaffected. */
    function patchCardImageAlt(section) {
      var cardImages = section.querySelectorAll('[data-carousel-card] .image-block__image[alt=""]');
      cardImages.forEach(function (img) {
        img.setAttribute('alt', 'Engagement ring');
      });
    }

    function initAltPatch() {
      document.querySelectorAll('.section-carousel').forEach(patchCardImageAlt);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAltPatch);
    } else {
      initAltPatch();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.section-carousel');
      if (section) patchCardImageAlt(section);
    });

    /* ----- Most Loved collection tab-swap + CTA-rebind -----
       Scoped per section via [data-section-id] so multiple carousel instances
       do not interfere. The section id must NOT appear inside javascript blocks;
       instead we hook on the data-section-id attribute set in the markup. */
    function initCollectionTabs(sectionEl) {
      var tablist = sectionEl.querySelector('[role="tablist"]');
      if (!tablist) return;

      var tabs = Array.prototype.slice.call(sectionEl.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(sectionEl.querySelectorAll('[data-tab-panel]'));
      var cta = sectionEl.querySelector('[data-collection-cta]');

      function activateTab(index) {
        tabs.forEach(function (tab, i) {
          var isActive = i === index;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach(function (panel, i) {
          if (i === index) {
            panel.removeAttribute('hidden');
            panel.classList.add('is-active');
          } else {
            panel.setAttribute('hidden', '');
            panel.classList.remove('is-active');
          }
        });
        if (cta && tabs[index]) {
          var label = tabs[index].getAttribute('data-shop-all-label');
          var href = tabs[index].getAttribute('data-shop-all-href');
          if (label) cta.textContent = label;
          if (href) cta.setAttribute('href', href);
        }
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          activateTab(i);
        });
        tab.addEventListener('keydown', function (evt) {
          var total = tabs.length;
          var current = i;
          if (evt.key === 'ArrowRight' || evt.key === 'ArrowDown') {
            evt.preventDefault();
            var next = (current + 1) % total;
            tabs[next].focus();
            activateTab(next);
          } else if (evt.key === 'ArrowLeft' || evt.key === 'ArrowUp') {
            evt.preventDefault();
            var prev = (current - 1 + total) % total;
            tabs[prev].focus();
            activateTab(prev);
          } else if (evt.key === 'Home') {
            evt.preventDefault();
            tabs[0].focus();
            activateTab(0);
          } else if (evt.key === 'End') {
            evt.preventDefault();
            tabs[total - 1].focus();
            activateTab(total - 1);
          } else if (evt.key === 'Enter' || evt.key === ' ') {
            evt.preventDefault();
            activateTab(current);
          }
        });
      });

      /* Initialise: ensure first tab is active on page load */
      activateTab(0);
    }

    function initAllCollectionTabs() {
      document.querySelectorAll('.section-carousel[data-section-id]').forEach(function (sectionEl) {
        initCollectionTabs(sectionEl);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllCollectionTabs);
    } else {
      initAllCollectionTabs();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var sectionEl = event.target.querySelector('.section-carousel[data-section-id]');
      if (sectionEl) initCollectionTabs(sectionEl);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-visual-filters"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const shapeLinks = document.querySelectorAll(
      '.collection-visual-filters__chip--shape[data-shape-filter="true"]'
    );

    if (!shapeLinks.length) return;

    shapeLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const paramName = link.dataset.shapeParamName;
        const paramValue = link.dataset.shapeParamValue;
        const isActive = link.dataset.shapeActive === 'true';

        if (!paramName || !paramValue) return;

        event.preventDefault();

        const nextUrl = new URL(window.location.href);

        if (isActive) {
          nextUrl.searchParams.delete(paramName);
        } else {
          nextUrl.searchParams.set(paramName, paramValue);
        }

        window.location.assign(nextUrl.toString());
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Reviews become a Swiper slider ONLY when there are > 3 reviews.
    // Desktop: 3 per view. Mobile: 2 stacked per page (grid rows). Clickable dots.
    // watchOverflow keeps it static (no dots) if a breakpoint already fits everything.
    function initReviews(section) {
      if (section.dataset.googleReviewsInit === 'true') return;
      var el = section.querySelector('[data-google-reviews-swiper]');
      if (!el) return;
      var slides = el.querySelectorAll('[data-google-reviews-slide]');
      if (slides.length <= 3) return; // 3 or fewer -> static grid, no slider/dots
      if (typeof Swiper === 'undefined') return; // swiper-bundle not ready yet; retried on load

      section.dataset.googleReviewsInit = 'true';
      var dots = section.querySelector('[data-google-reviews-dots]'); // dots live outside .swiper

      new Swiper(el, {
        slidesPerView: 1,
        grid: { rows: 2, fill: 'row' },
        spaceBetween: 16,
        watchOverflow: true,
        a11y: { enabled: true },
        pagination: dots ? { el: dots, clickable: true } : false,
        breakpoints: {
          750: { slidesPerView: 3, grid: { rows: 1 }, spaceBetween: 20 }
        }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-google-reviews]').forEach(initReviews);
    }

    function boot() {
      initAll();
      // If swiper-bundle.js (deferred) hadn't executed yet, retry once it has loaded.
      if (typeof Swiper === 'undefined') {
        window.addEventListener('load', initAll, { once: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-google-reviews]');
      if (section) {
        section.dataset.googleReviewsInit = '';
        initReviews(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["designer-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Center an incomplete last row WITHOUT leaving CSS grid. The grid is laid out
    // as 8 half-columns (each tile spans --dg-span = 2), so the leftover row can be
    // nudged by half a tile. Re-runs on tab filter + resize, and counts only VISIBLE
    // (non-[hidden]) tiles, so it stays correct as tabs show/hide logos.
    function centerLastRow(root) {
      var grid = root.querySelector('.designer-gallery__grid');
      if (!grid) return;
      var allTiles = Array.prototype.slice.call(
        grid.querySelectorAll('.designer-gallery__tile')
      );
      // Clear any previous offset first so the measurement is clean.
      allTiles.forEach(function (t) { t.style.gridColumn = ''; });

      var visible = allTiles.filter(function (t) { return !t.hasAttribute('hidden'); });
      if (visible.length < 2) return;

      var tracks = getComputedStyle(grid)
        .gridTemplateColumns.split(' ')
        .filter(Boolean).length;
      var span = parseInt(getComputedStyle(grid).getPropertyValue('--dg-span'), 10) || 2;
      var cols = Math.floor(tracks / span);
      if (cols < 2) return;

      var rem = visible.length % cols;
      if (rem === 0) return; // last row is full -> nothing to center

      // Leading empty half-columns on each side, in track units.
      var leading = (tracks - rem * span) / 2;
      if (leading !== Math.floor(leading)) return; // can't center cleanly at this scheme

      visible[visible.length - rem].style.gridColumn = (leading + 1) + ' / span ' + span;
    }

    function initGallery(root) {
      if (root.dataset.designerTabsInit === 'true') return;
      root.dataset.designerTabsInit = 'true';

      var tabs = Array.prototype.slice.call(
        root.querySelectorAll('.designer-gallery__tab')
      );
      var tiles = Array.prototype.slice.call(
        root.querySelectorAll('.designer-gallery__tile')
      );
      if (!tiles.length) return;

      // No tabs: nothing to filter, but still center a short last row once.
      if (!tabs.length) {
        centerLastRow(root);
        return;
      }

      // A tile belongs to a tab if the tab name appears in its (comma-separated)
      // data-categories list. Case-insensitive. No fallback: an empty tab shows
      // empty, so the filtering is visibly working and missing assignments are obvious.
      function tilesFor(category) {
        var want = (category || '').trim().toUpperCase();
        return tiles.filter(function (tile) {
          var list = (tile.dataset.categories || '').toUpperCase().split(',');
          for (var k = 0; k < list.length; k++) {
            if (list[k].trim() === want) return true;
          }
          return false;
        });
      }

      var ctas = Array.prototype.slice.call(root.querySelectorAll('[data-tab-cta]'));

      // Shows the CTA whose tab matches the active one. With no tab_cta blocks
      // configured the section falls back to a single static footer, which has
      // no [data-tab-cta] and is therefore left alone here.
      function showCtaFor(category) {
        if (!ctas.length) return;
        var want = (category || '').trim().toUpperCase();
        ctas.forEach(function (el) {
          var mine = (el.getAttribute('data-tab-cta') || '').trim().toUpperCase();
          if (mine === want) {
            el.removeAttribute('hidden');
          } else {
            el.setAttribute('hidden', '');
          }
        });
      }

      function activate(tab) {
        var category = tab.dataset.tab;
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
        });
        showCtaFor(category);
        var visible = tilesFor(category);
        tiles.forEach(function (tile) {
          if (visible.indexOf(tile) !== -1) {
            tile.removeAttribute('hidden');
          } else {
            tile.setAttribute('hidden', '');
          }
        });
        centerLastRow(root);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab);
        });
        tab.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            activate(tab);
            tab.focus();
          }
        });
      });

      // Initial state: the first (JEWELRY) tab is active on render.
      var initial = tabs.filter(function (t) {
        return t.classList.contains('is-active');
      })[0] || tabs[0];
      activate(initial);
    }

    function initAll() {
      var roots = document.querySelectorAll('.section-designer-gallery');
      Array.prototype.forEach.call(roots, initGallery);
    }

    // Columns flip between desktop and mobile, so re-center on resize (debounced).
    var resizeRAF;
    window.addEventListener('resize', function () {
      if (resizeRAF) cancelAnimationFrame(resizeRAF);
      resizeRAF = requestAnimationFrame(function () {
        var roots = document.querySelectorAll('.section-designer-gallery');
        Array.prototype.forEach.call(roots, centerLastRow);
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Theme editor: re-init when a section is loaded/re-rendered.
    //
    // event.target IS the section wrapper, and the schema puts
    // `section-designer-gallery` on that same element — so querySelector alone
    // looked for a DESCENDANT with the class, found nothing, and left every tile
    // visible until the next full page load. Check the target itself first.
    document.addEventListener('shopify:section:load', function (event) {
      var el = event.target;
      var root =
        el && el.classList && el.classList.contains('section-designer-gallery')
          ? el
          : el && el.querySelector
            ? el.querySelector('.section-designer-gallery')
            : null;
      if (root) {
        root.dataset.designerTabsInit = '';
        initGallery(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

    const animateOpen = (details, answer) => {
      details.classList.remove('is-closing');
      details.open = true;

      answer.style.maxHeight = '0px';
      answer.style.opacity = '0';

      requestAnimationFrame(() => {
        answer.style.maxHeight = `${answer.scrollHeight}px`;
        answer.style.opacity = '1';
      });

      const onEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        answer.style.maxHeight = 'none';
        answer.removeEventListener('transitionend', onEnd);
      };

      answer.addEventListener('transitionend', onEnd);
    };

    const animateClose = (details, answer) => {
      details.classList.add('is-closing');
      answer.style.maxHeight = `${answer.scrollHeight}px`;
      answer.style.opacity = '1';

      requestAnimationFrame(() => {
        answer.style.maxHeight = '0px';
        answer.style.opacity = '0';
      });

      const onEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        details.open = false;
        details.classList.remove('is-closing');
        answer.style.maxHeight = '';
        answer.style.opacity = '';
        answer.removeEventListener('transitionend', onEnd);
      };

      answer.addEventListener('transitionend', onEnd);
    };

    const initFaqAnimations = (root) => {
      const detailsItems = root.querySelectorAll('.faq_item');
      if (!detailsItems.length) return;

      detailsItems.forEach((details) => {
        if (details.dataset.faqAnimated === 'true') return;

        const summary = details.querySelector('.faq_item__summary');
        const answer = details.querySelector('.faq_item__answer');
        if (!summary || !answer) return;

        details.dataset.faqAnimated = 'true';

        if (details.open) {
          answer.style.maxHeight = 'none';
          answer.style.opacity = '1';
        }

        summary.addEventListener('click', (event) => {
          if (details.dataset.isAnimating === 'true') {
            event.preventDefault();
            return;
          }

          event.preventDefault();

          if (window.matchMedia(REDUCED_MOTION_QUERY).matches) {
            details.open = !details.open;
            answer.style.maxHeight = details.open ? 'none' : '';
            answer.style.opacity = details.open ? '1' : '';
            details.classList.remove('is-closing');
            return;
          }

          details.dataset.isAnimating = 'true';

          if (details.open) {
            animateClose(details, answer);
          } else {
            animateOpen(details, answer);
          }

          window.setTimeout(() => {
            details.dataset.isAnimating = 'false';
          }, 320);
        });
      });
    };

    const initialize = (scope) => {
      const sectionRoots = scope.matches?.('.faqs') ? [scope] : scope.querySelectorAll?.('.faqs');
      if (!sectionRoots) return;
      sectionRoots.forEach((section) => initFaqAnimations(section));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document));
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function isMobile() {
      return window.matchMedia('(max-width: 1023px)').matches;
    }
    var toggles = document.querySelectorAll('[data-footer-accordion-toggle]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!isMobile()) return;
        var col = btn.closest('[data-footer-accordion]');
        if (!col) return;
        var open = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roberts-faqs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaqp(root) {
      if (root.dataset.faqpInit === 'true') return;
      root.dataset.faqpInit = 'true';
      var links = Array.prototype.slice.call(root.querySelectorAll('[data-faqp-link]'));
      var cats = Array.prototype.slice.call(root.querySelectorAll('[data-faqp-cat]'));
      if (!links.length || !cats.length) return;

      function setActive(i) {
        links.forEach(function (l) {
          l.classList.toggle('is-active', l.getAttribute('data-faqp-link') === String(i));
        });
      }

      // Smooth scroll + active on click
      links.forEach(function (l) {
        l.addEventListener('click', function (e) {
          var id = l.getAttribute('href');
          var target = id ? root.querySelector(id) : null;
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setActive(l.getAttribute('data-faqp-link'));
          }
        });
      });

      // Scrollspy
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setActive(entry.target.getAttribute('data-faqp-cat'));
          });
        }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
        cats.forEach(function (c) { io.observe(c); });
      }
    }

    function initAll() { document.querySelectorAll('[data-faqp]').forEach(initFaqp); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else { initAll(); }
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-faqp]');
      if (root) { root.dataset.faqpInit = ''; initFaqp(root); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roberts-size-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function parseMap(raw) {
      // Lines like "6 => 51.3-52.5" -> [{size:'6', low:51.3, high:52.5}]
      if (!raw) return [];
      return raw.split(/\r?\n/).map(function (line) {
        var m = line.split('=>');
        if (m.length !== 2) return null;
        var size = m[0].trim();
        var range = m[1].trim().split('-');
        if (range.length !== 2) return null;
        var low = parseFloat(range[0]);
        var high = parseFloat(range[1]);
        if (isNaN(low) || isNaN(high)) return null;
        return { size: size, low: low, high: high };
      }).filter(Boolean);
    }

    function initCalc(modal) {
      var calc = modal.querySelector('[data-sg-calc]');
      if (!calc) return;
      var input = calc.querySelector('[data-sg-input]');
      var result = calc.querySelector('[data-sg-result]');
      var btn = calc.querySelector('[data-sg-btn]');
      if (!input || !result) return;

      var min = parseFloat(calc.getAttribute('data-min'));
      var max = parseFloat(calc.getAttribute('data-max'));
      var prefix = calc.getAttribute('data-prefix') || 'Recommended size:';
      var noMatch = calc.getAttribute('data-nomatch') || 'No exact match.';
      var map = parseMap(calc.getAttribute('data-map'));

      function clearRows() {
        var rows = modal.querySelectorAll('[data-sg-size]');
        Array.prototype.forEach.call(rows, function (r) { r.classList.remove('is-match'); });
      }
      function highlight(size) {
        clearRows();
        var rows = modal.querySelectorAll('[data-sg-size]');
        Array.prototype.forEach.call(rows, function (r) {
          if (r.getAttribute('data-sg-size') === String(size)) r.classList.add('is-match');
        });
      }
      function setMsg(msg, ok) {
        result.textContent = msg;
        result.classList.toggle('is-error', !ok);
        result.classList.toggle('is-ok', !!ok);
      }

      function evaluate() {
        var raw = (input.value || '').trim().replace(',', '.');
        if (raw === '') { setMsg('Please enter a measurement.', false); input.setAttribute('aria-invalid', 'true'); clearRows(); return; }
        var v = parseFloat(raw);
        if (isNaN(v)) { setMsg('Please enter a valid number.', false); input.setAttribute('aria-invalid', 'true'); clearRows(); return; }
        if ((!isNaN(min) && v < min) || (!isNaN(max) && v > max)) {
          var lo = isNaN(min) ? '' : min;
          var hi = isNaN(max) ? '' : max;
          setMsg('Please enter a value between ' + lo + ' and ' + hi + '.', false);
          input.setAttribute('aria-invalid', 'true'); clearRows(); return;
        }
        input.removeAttribute('aria-invalid');
        var hit = null;
        for (var i = 0; i < map.length; i++) {
          if (v >= map[i].low && v <= map[i].high) { hit = map[i]; break; }
        }
        if (hit) { setMsg(prefix + ' ' + hit.size, true); highlight(hit.size); }
        else { setMsg(noMatch, false); clearRows(); }
      }

      if (btn) btn.addEventListener('click', evaluate);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); evaluate(); }
      });
    }

    function init() {
      var modal = document.getElementById('rj-size-guide-modal');
      if (modal) initCalc(modal);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
